import { render, staticRenderFns } from "./SellersList.vue?vue&type=template&id=145ef58c&scoped=true"
import script from "./SellersList.vue?vue&type=script&lang=js"
export * from "./SellersList.vue?vue&type=script&lang=js"
import style0 from "./SellersList.vue?vue&type=style&index=0&id=145ef58c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145ef58c",
  null
  
)

export default component.exports